/* GENERATED FROM tenantMgr.proto. DO NOT EDIT MANUALLY. */
/* tslint:disabled */
/* eslint-disable */

import {
  APIRequest,
  APIResponse,
  makeRequest,
  preProcessingResponse
} from '../'
import * as base from './base.service'
import * as commonHdr from './commonHdr.service'

export class TenantMgr {
  static GetTenantEndpoint = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<GetTenantReq, {}, GetTenantResp>): Promise<
    APIResponse<GetTenantResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/tenants`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<GetTenantResp>>()
          .then<APIResponse<GetTenantResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static UpdateTenantEndpoint = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<UpdateTenantReq, {}, UpdateTenantResp>): Promise<
    APIResponse<UpdateTenantResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/tenants`,
      method: 'PATCH',
      reqOptions: {
        body: JSON.stringify(params),
        ...options
      }
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<UpdateTenantResp>>()
          .then<APIResponse<UpdateTenantResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static UpdateUserEndpoint = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<UpdateUserReq, {}, UpdateUserResp>): Promise<
    APIResponse<UpdateUserResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/tenants/users`,
      method: 'PATCH',
      reqOptions: {
        body: JSON.stringify(params),
        ...options
      }
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<UpdateUserResp>>()
          .then<APIResponse<UpdateUserResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static GetUser = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<GetUserReq, {}, GetUserResp>): Promise<
    APIResponse<GetUserResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/tenants/users`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<GetUserResp>>()
          .then<APIResponse<GetUserResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static GetAuthInfo = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<AuthInfoReq, {}, AuthInfoResp>): Promise<
    APIResponse<AuthInfoResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/tenants/users/auth`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<AuthInfoResp>>()
          .then<APIResponse<AuthInfoResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static SetShadowAccountName = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<
    SetShadowAccountNameReq,
    {},
    SetShadowAccountNameResp
  >): Promise<APIResponse<SetShadowAccountNameResp>> =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/tenants/set-shadow-account-name`,
      method: 'PATCH',
      reqOptions: {
        body: JSON.stringify(params),
        ...options
      }
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<SetShadowAccountNameResp>>()
          .then<APIResponse<SetShadowAccountNameResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static GetNotificationInfo = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<GetNotificationInfoReq, {}, GetNotificationInfoResp>): Promise<
    APIResponse<GetNotificationInfoResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/tenants/notification`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<GetNotificationInfoResp>>()
          .then<APIResponse<GetNotificationInfoResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static UpdateNotificationInfo = ({
    params,
    queryVars,
    options,
    makeRequestOptions
  }: APIRequest<
    UpdateNotificationInfoReq,
    { severity: string },
    UpdateNotificationInfoResp
  >): Promise<APIResponse<UpdateNotificationInfoResp>> =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/tenants/notification/${queryVars.severity}`,
      method: 'PUT',
      reqOptions: {
        body: JSON.stringify(params),
        ...options
      }
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<UpdateNotificationInfoResp>>()
          .then<APIResponse<UpdateNotificationInfoResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static GetFeatureFlag = ({
    params,
    queryVars,
    options,
    makeRequestOptions
  }: APIRequest<
    GetFeatureFlagReq,
    { featureflag: string },
    GetFeatureFlagResp
  >): Promise<APIResponse<GetFeatureFlagResp>> =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/tenants/featureflag/${queryVars.featureflag}`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<GetFeatureFlagResp>>()
          .then<APIResponse<GetFeatureFlagResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static ListOrganizations = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<ListOrganizationsReq, {}, ListOrganizationsResp>): Promise<
    APIResponse<ListOrganizationsResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/tenants/organizations`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<ListOrganizationsResp>>()
          .then<APIResponse<ListOrganizationsResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static ListCloudOrganizations = ({
    params,
    queryVars,
    options,
    makeRequestOptions
  }: APIRequest<
    ListCloudOrganizationsReq,
    { cloud_type: string },
    ListCloudOrganizationsResp
  >): Promise<APIResponse<ListCloudOrganizationsResp>> =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/tenants/organizations/${queryVars.cloud_type}`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<ListCloudOrganizationsResp>>()
          .then<APIResponse<ListCloudOrganizationsResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static GetOrganization = ({
    params,
    queryVars,
    options,
    makeRequestOptions
  }: APIRequest<
    GetOrganizationReq,
    { cloud_type: string; organization_uid: string },
    GetOrganizationResp
  >): Promise<APIResponse<GetOrganizationResp>> =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/tenants/organizations/${queryVars.cloud_type}/${queryVars.organization_uid}`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<GetOrganizationResp>>()
          .then<APIResponse<GetOrganizationResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static CreateOrganization = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<CreateOrganizationReq, {}, CreateOrganizationResp>): Promise<
    APIResponse<CreateOrganizationResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/tenants/organizations`,
      method: 'POST',
      reqOptions: {
        body: JSON.stringify(params),
        ...options
      }
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<CreateOrganizationResp>>()
          .then<APIResponse<CreateOrganizationResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static DeleteOrganization = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<DeleteOrganizationReq, {}, DeleteOrganizationResp>): Promise<
    APIResponse<DeleteOrganizationResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/tenants/organizations`,
      method: 'DELETE',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<DeleteOrganizationResp>>()
          .then<APIResponse<DeleteOrganizationResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static UpdateOrganization = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<UpdateOrganizationReq, {}, UpdateOrganizationResp>): Promise<
    APIResponse<UpdateOrganizationResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/tenants/organizations`,
      method: 'PATCH',
      reqOptions: {
        body: JSON.stringify(params),
        ...options
      }
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<UpdateOrganizationResp>>()
          .then<APIResponse<UpdateOrganizationResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static CreateAccount = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<CreateAccountReq, {}, CreateAccountResp>): Promise<
    APIResponse<CreateAccountResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/beta/accounts`,
      method: 'POST',
      reqOptions: {
        body: JSON.stringify(params),
        ...options
      }
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<CreateAccountResp>>()
          .then<APIResponse<CreateAccountResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static DeleteAccount = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<DeleteAccountReq, {}, DeleteAccountResp>): Promise<
    APIResponse<DeleteAccountResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/beta/accounts`,
      method: 'DELETE',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<DeleteAccountResp>>()
          .then<APIResponse<DeleteAccountResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static UpdateTenantAccount = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<UpdateTenantAccountReq, {}, UpdateTenantAccountResp>): Promise<
    APIResponse<UpdateTenantAccountResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/beta/accounts`,
      method: 'PATCH',
      reqOptions: {
        body: JSON.stringify(params),
        ...options
      }
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<UpdateTenantAccountResp>>()
          .then<APIResponse<UpdateTenantAccountResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static ListAccounts = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<ListAccountsReq, {}, ListAccountsResp>): Promise<
    APIResponse<ListAccountsResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/beta/accounts`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<ListAccountsResp>>()
          .then<APIResponse<ListAccountsResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static ListCloudAccounts = ({
    params,
    queryVars,
    options,
    makeRequestOptions
  }: APIRequest<
    ListCloudAccountsReq,
    { cloud_type: string },
    ListCloudAccountsResp
  >): Promise<APIResponse<ListCloudAccountsResp>> =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/beta/accounts/${queryVars.cloud_type}`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<ListCloudAccountsResp>>()
          .then<APIResponse<ListCloudAccountsResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })
}

export interface AuthInfoReq {
  req_hdr?: base.ReqHdr
  email?: string
}

export interface AuthInfoResp {
  resp_hdr?: base.RespHdr
  user_pool_id?: string
  client_id?: string
  user_source?: commonHdr.UserSource
  idn_api_url?: string
  api_url?: string
}

export interface VerifyUserResp {
  resp_hdr?: base.RespHdr
  verified?: boolean
}

export interface UpdateFields {
  field_name?: string
  field_value?: boolean
}

export interface AccountInfoUpdate {
  account_id?: string
  fields?: UpdateFields[]
}

export interface UpdateAccountInfoInternalReq {
  req_hdr?: base.ReqHdr
  update_info?: AccountInfoUpdate[]
  tenant_id?: string
}

export interface UpdateAccountInfoResp {
  resp_hdr?: base.RespHdr
  account_info?: base.AccountInfo[]
}

export interface UpdateAccountStatus {
  status?: base.AccountStatusEnum
  status_reason?: string
}

export interface UpdateAccountStatusReq {
  req_hdr?: base.ReqHdr
  account_status?: UpdateAccountStatusReq_AccountStatusEntry
  tenant_id?: string
}

export interface UpdateAccountStatusReq_AccountStatusEntry {
  [key: string]: UpdateAccountStatus
}

export interface CreateTenantResp {
  resp_hdr?: base.RespHdr
  user_pool_id?: string
  client_id?: string
}

export interface GetTenantReq {
  req_hdr?: base.ReqHdr
  tenant_id?: string
  include_organizations?: boolean
}

export interface GetTenantResp {
  resp_hdr?: base.RespHdr
  tenant?: commonHdr.TenantInfo
}

export interface UpdateTenantReq {
  req_hdr?: base.ReqHdr
  tenant?: commonHdr.TenantInfo
}

export interface UpdateTenantResp {
  resp_hdr?: base.RespHdr
  tenant?: commonHdr.TenantInfo
}

export interface DeleteTenantReq {
  req_hdr?: base.ReqHdr
  tenant_id?: string
}

export interface DeleteTenantResp {
  resp_hdr?: base.RespHdr
}

export interface GetAllTenantsReq {
  req_hdr?: base.ReqHdr
}

export interface GetAllTenantsResp {
  resp_hdr?: base.RespHdr
  tenant?: commonHdr.TenantInfo[]
}

export interface CreateUserReq {
  req_hdr?: base.ReqHdr
  user?: commonHdr.UserInfo
  tenant_id?: string
  url?: string
}

export interface CreateUserResp {
  resp_hdr?: base.RespHdr
  status?: string
}

export interface UpdateUserReq {
  req_hdr?: base.ReqHdr
  tenant_id?: string
  user?: commonHdr.UserInfo
}

export interface UpdateUserResp {
  resp_hdr?: base.RespHdr
  user?: commonHdr.UserInfo
}

export interface GetUserReq {
  req_hdr?: base.ReqHdr
  email?: string
  username?: string
  tenant_id?: string
}

export interface GetUserResp {
  resp_hdr?: base.RespHdr
  user?: commonHdr.UserInfo
}

export interface DeleteUserReq {
  req_hdr?: base.ReqHdr
  email?: string
  tenant_id?: string
}

export interface DeleteUserResp {
  resp_hdr?: base.RespHdr
}

export interface GetTenantsReq {
  req_hdr?: base.ReqHdr
}

export interface GetTenantsResp {
  resp_hdr?: base.RespHdr
  tenants?: commonHdr.TenantInfo[]
}

export interface CreateTenantReq {
  req_hdr?: base.ReqHdr
  tenant?: commonHdr.TenantInfo
  user?: commonHdr.UserInfo
  url?: string
  user_source?: commonHdr.UserSource
  fsm_start_time?: string
}

export interface SetShadowAccountNameReq {
  req_hdr?: base.ReqHdr
  account_id?: string
  account_name?: string
}

export interface SetShadowAccountNameResp {
  resp_hdr?: base.RespHdr
}

export interface StartTime {
  timestamp?: string
}

export interface CreateTenantSignalReq {
  req_hdr?: base.ReqHdr
  tenant?: commonHdr.TenantInfo
  user?: commonHdr.UserInfo
  Rollback?: boolean
  startTime?: StartTime
}

export interface CreateTenantSignalResp {
  resp_hdr?: base.RespHdr
}

export interface DeleteTenantSignalReq {
  req_hdr?: base.ReqHdr
  tenant?: commonHdr.TenantInfo
}

export interface DeleteTenantSignalResp {
  resp_hdr?: base.RespHdr
}

export interface UpdateTenantSignalReq {
  req_hdr?: base.ReqHdr
  tenant?: commonHdr.TenantInfo
}

export interface UpdateTenantSignalResp {
  resp_hdr?: base.RespHdr
}

export interface UpdateTenantUpdateOnboardingDoneReq {
  req_hdr?: base.ReqHdr
  tenant_id?: string
  is_onboarding_done?: boolean
}

export interface UpdateTenantUpdateOnboardingDoneResp {
  resp_hdr?: base.RespHdr
}

export interface UpdateTenantAccountsReq {
  req_hdr?: base.ReqHdr
  tenant_id?: string[]
}

export interface UpdateTenantAccountsResp {
  resp_hdr?: base.RespHdr
  tenant_id?: string[]
  status?: string
}

export interface GetNotificationInfoReq {
  req_hdr?: base.ReqHdr
}

export interface GetNotificationInfoInternalReq {
  req_hdr?: base.ReqHdr
  tenant_id?: string
}

export interface GetNotificationInfoResp {
  resp_hdr?: base.RespHdr
  notification_info?: commonHdr.NotificationInfo[]
}

export interface UpdateNotificationInfoReq {
  req_hdr?: base.ReqHdr
  severity?: commonHdr.AlertSeverityEnum
  notification_info?: commonHdr.NotificationInfo
}

export interface UpdateNotificationInfoResp {
  resp_hdr?: base.RespHdr
}

export interface ListOrganizationsReq {
  req_hdr?: base.ReqHdr
  cloud_type?: base.CloudTypeEnum
  organization_uid?: string
}

export interface ListOrganizationsResp {
  resp_hdr?: base.RespHdr
  organization?: base.OrganizationInfo[]
}

export interface CreateOrganizationReq {
  req_hdr?: base.ReqHdr
  organization?: base.OrganizationInfo
}

export interface CreateOrganizationResp {
  resp_hdr?: base.RespHdr
}

export interface ListCloudOrganizationsReq {
  req_hdr?: base.ReqHdr
  cloud_type?: base.CloudTypeEnum
}

export interface ListCloudOrganizationsResp {
  resp_hdr?: base.RespHdr
  organization?: base.OrganizationInfo[]
}

export interface GetOrganizationReq {
  req_hdr?: base.ReqHdr
  cloud_type?: base.CloudTypeEnum
  organization_uid?: string
}

export interface GetOrganizationResp {
  resp_hdr?: base.RespHdr
  organization?: base.OrganizationInfo
}

export interface DeleteOrganizationReq {
  req_hdr?: base.ReqHdr
  cloud_type?: base.CloudTypeEnum
  organization_uid?: string
}

export interface DeleteOrganizationResp {
  resp_hdr?: base.RespHdr
}

export interface UpdateOrganizationReq {
  req_hdr?: base.ReqHdr
  organization?: base.OrganizationInfo
}

export interface UpdateOrganizationResp {
  resp_hdr?: base.RespHdr
  organization?: base.OrganizationInfo
}

export interface GetFeatureFlagReq {
  req_hdr?: base.ReqHdr
  featureflag?: string
  default?: boolean
}

export interface GetFeatureFlagResp {
  resp_hdr?: base.RespHdr
  featureflag?: string
  value?: boolean
}

export interface CreateAccountReq {
  req_hdr?: base.ReqHdr
  account?: base.AccountInfo
}

export interface CreateAccountResp {
  resp_hdr?: base.RespHdr
}

export interface DeleteAccountReq {
  req_hdr?: base.ReqHdr
  account_id?: string
}

export interface DeleteAccountResp {
  resp_hdr?: base.RespHdr
}

export interface UpdateTenantAccountReq {
  req_hdr?: base.ReqHdr
  account?: base.AccountInfo
}

export interface UpdateTenantAccountResp {
  resp_hdr?: base.RespHdr
}

export interface ListAccountsReq {
  req_hdr?: base.ReqHdr
  tenant_id?: string
}

export interface ListAccountsResp {
  resp_hdr?: base.RespHdr
  account_list?: base.AccountInfo[]
}

export interface ListCloudAccountsReq {
  req_hdr?: base.ReqHdr
  cloud_type?: base.CloudTypeEnum
}

export interface ListCloudAccountsResp {
  resp_hdr?: base.RespHdr
  account_list?: base.AccountInfo[]
}
